import { useNavigate } from 'react-router-dom';

import { useBoundStore } from 'app/store';
import { OneBtnFooter } from 'widgets/HsptlzForm/ui';
import { ReadonlyFormContainer } from 'features/HsptlzForm/ui';
import { ArrowIcon02 } from 'shared/ui/icon';

import { ErrorGuide, ErrorGuideWithBox } from './GuideBox';

// 제출 시 환자정보 상태에서 redirectUrl 사용 해 해당 페이지로 이동

const ProcessHsptlzForm = ({ failMsg }) => {
  const processFormData = useBoundStore((state) => state['hsptlzForm'].processFormData);
  const navigate = useNavigate();

  if (failMsg)
    return (
      <>
        <ErrorGuideWithBox failMsg={failMsg} />
        <OneBtnFooter
          text={'톡채널로 돌아가기'}
          btnStyle=''
          handleClick={() => {
            if (/android/i.test(navigator.userAgent)) {
              window.location.href = 'kakaotalk://inappbrowser/close';
            }

            if (/iPad|iPhone|iPod/.test(navigator.userAgent)) {
              window.location.href = 'kakaotalk://web/close';
            }
          }}
        />
      </>
    );

  if (Object.keys(processFormData).length === 0)
    return (
      <>
        <ErrorGuide
          title='작성할 동의서가 없어요'
          description='동의서를 이미 모두 작성하셨거나, 병원에서 작성해야 할 동의서를 준비 중일 수 있어요.'
        />
        <OneBtnFooter
          text={'톡채널로 돌아가기'}
          btnStyle=''
          handleClick={() => {
            if (/android/i.test(navigator.userAgent)) {
              window.location.href = 'kakaotalk://inappbrowser/close';
            }

            if (/iPad|iPhone|iPod/.test(navigator.userAgent)) {
              window.location.href = 'kakaotalk://web/close';
            }
          }}
        />
      </>
    );

  return (
    <div className='ccrc-info-list'>
      <div className='myagree-item'>
        {Object.values(processFormData).map((item) => (
          <div
            className='con-item'
            key={item.contentCode}
            onClick={() => {
              if (item.caregiverUseYn === 'Y') {
                navigate(`caregiver-form/${item.contentCode}`);
              } else {
                navigate(`mobile-form/${item.contentCode}`);
              }
            }}
          >
            <span className='agree-title'>{item.contentName}</span>
            <ArrowIcon02 />
          </div>
        ))}
      </div>
    </div>
  );
};

const SubmittedHsptlzForm = () => {
  const submittedFormData = useBoundStore((state) => state['hsptlzForm'].submittedFormData);

  const navigate = useNavigate();

  if (Object.keys(submittedFormData).length === 0)
    return (
      <>
        <ErrorGuide
          title='확인 가능한 동의서가 없어요'
          description='제출한 동의서가 없거나, 입원 기간이 아닌 경우에는 제출한 동의서를 다시 확인할 수 없어요.'
        />
        <OneBtnFooter
          text={'톡채널로 돌아가기'}
          btnStyle=''
          handleClick={() => {
            if (/android/i.test(navigator.userAgent)) {
              window.location.href = 'kakaotalk://inappbrowser/close';
            }

            if (/iPad|iPhone|iPod/.test(navigator.userAgent)) {
              window.location.href = 'kakaotalk://web/close';
            }
          }}
        />
      </>
    );

  return (
    <div className='ccrc-info-list'>
      <div className='myagree-item'>
        {Object.values(submittedFormData).map((item, index) => (
          <div
            className='con-item'
            key={item.contentCode}
            onClick={() => {
              navigate(`submitted-form/${item.contentCode}`);
            }}
          >
            <span className='agree-title'>{item.contentName}</span>
            <ArrowIcon02 />
          </div>
        ))}
      </div>
    </div>
  );
};

export const TabContents = ({ rule, index }) => {
  const { failMsg } = useBoundStore((state) => state['hsptlzForm'].redirectData);

  if (rule === 'info') return <ReadonlyFormContainer />;
  if (rule === 'process') return <ProcessHsptlzForm dataKey={index} failMsg={failMsg} />;
  if (rule === 'submitted') return <SubmittedHsptlzForm dataKey={index} />;
};
